import PagingSetting from "./KrPagingSetting.vue";
import { install } from "@kurundata-ui-questionnaire/utils/install";

const KrPagingSetting = install(PagingSetting); // 生成带有 install 方法的组件

export default KrPagingSetting;
